/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type LifeStyleExpenseEntryMode = (typeof LifeStyleExpenseEntryMode)[keyof typeof LifeStyleExpenseEntryMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LifeStyleExpenseEntryMode = {
  aggregate: "aggregate",
  individual: "individual",
} as const;
